export const regexStrongPassword =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!$%=\#\&\-\:\;\@\^\_\~¡ªº°¿\'\"\(\)\|\>\<\*\,\.\[\]\{\}\?\/\+\\])[0-9a-zA-Z!$%=\#\&\-\:\;\@\^\_\~¡ªº°¿\'\"\(\)\|\>\<\*\,\.\[\]\{\}\?\/\+\\]{8,}$/;

export const regexSpecialCharacters =
  /(?=.*[!$%=\#\&\-\:\;\@\^\_\~¡ªº°¿\'\"\(\)\|\>\<\*\,\.\[\]\{\}\?\/\+\\])/;
